import { render, staticRenderFns } from "./DashboardTodosList.vue?vue&type=template&id=6dafbb46&scoped=true&"
import script from "./DashboardTodosList.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardTodosList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardTodosList.vue?vue&type=style&index=0&id=6dafbb46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafbb46",
  null
  
)

export default component.exports